import { render, staticRenderFns } from "./SysDataSourceModal.vue?vue&type=template&id=5c977102&scoped=true"
import script from "./SysDataSourceModal.vue?vue&type=script&lang=js"
export * from "./SysDataSourceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c977102",
  null
  
)

export default component.exports